import {
	LOAD_MANAGER_SUCCESS,
	SAVE_MANAGER_SUCCESS,
    CLEAR_MANAGER
} from '../../actions/types';

const INITIAL_STATE = {
	id: -1,
	name: '',
	email: '',
	password: '',
	phone: '',
	language: '',
	role: ''
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOAD_MANAGER_SUCCESS:
			return action.payload;
		case SAVE_MANAGER_SUCCESS:
			return action.payload;
        case CLEAR_MANAGER:
            return INITIAL_STATE;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/users/ManagersReducer.js